import { useIntl } from 'react-intl';
import { WaitCauseDTO, WaitRankingLevel } from '../../dto/ServiceStatisticsDTO';
import { causeText, isCriticalPriorityCause, MAX_CAUSES_SHOWN } from './waitCauseText';

interface WaitCauseListProps {
    causes: WaitCauseDTO[];
    level: WaitRankingLevel;
}

/**
 * Las posibles causas de la espera de una fila, una por renglón (hasta tres). Son hipótesis a partir de los datos, no un
 * diagnóstico: sin ninguna y con la espera fuera de lo normal, lo dice. La espera de un código de Inmediato o Emergencia
 * por encima del objetivo va con un ícono y en negrita, así no depende solo del color de la fila.
 */
export default function WaitCauseList({ causes, level }: WaitCauseListProps) {
    const intl = useIntl();

    if (causes.length === 0) {
        return (
            <p className="ss-causes ss-causes--none">
                {level === 'OK' ? '—' : intl.formatMessage({ id: 'ServicesStatisticsCauseNone' })}
            </p>
        );
    }

    return (
        <ul className="ss-causes">
            {causes.slice(0, MAX_CAUSES_SHOWN).map((cause, index) => {
                const critical = isCriticalPriorityCause(cause);
                return (
                    <li key={`${cause.code}-${index}`} className={critical ? 'ss-causes__item ss-causes__item--critical' : 'ss-causes__item'}>
                        {critical && <i className="pi pi-exclamation-triangle" aria-hidden="true" />}
                        <span>{causeText(intl, cause)}</span>
                    </li>
                );
            })}
        </ul>
    );
}
